import { render, staticRenderFns } from "./RegistrationComplete.vue?vue&type=template&id=f5f3e16c&scoped=true&"
import script from "./RegistrationComplete.js?vue&type=script&lang=js&"
export * from "./RegistrationComplete.js?vue&type=script&lang=js&"
import style0 from "./RegistrationComplete.scss?vue&type=style&index=0&id=f5f3e16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f3e16c",
  null
  
)

export default component.exports